import React from 'react'
import { Image, StyleSheet } from 'react-native'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import { B2, B4, Button, H4, SH1, SH4, Stack, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { LinearGradient } from 'expo-linear-gradient'
import { styled } from 'nativewind'

import { IProduct } from '../../hooks/useBrandRecommendations'
import Approval from './../../assets/svg/approved.svg'
import CautionRedImage from './../../assets/svg/cautionRed.svg'
import GradientText from './GradientText'

const LinearGradientLine = styled(LinearGradient, 'h-[2] w-[25%]')

export default function MagnetCrossSell({ item }: { item: IProduct }) {
  const navigation = useNavigation()
  console.log('item', item)
  const onBannerPress = () => {
    navigation.navigate('MagnetBenefits')
  }
  return (
    <Stack className="items-center justify-center px-3 py-4">
      <CautionRedImage width={50} height={40} />
      <SH1 className="text-grays-80 mt-3">
        {i18n.t('recommendationState.preApprovedIneligibility.header')}
      </SH1>
      <B2 className="text-grays-70 mt-1 text-center">
        {i18n.t('recommendationState.preApprovedIneligibility.subheader')}
      </B2>
      <XStack className="mt-6 w-[100%] items-center justify-center">
        <LinearGradientLine
          colors={['#5E9FFF', '#FFFFFF']}
          start={{ x: 1, y: 0 }}
          end={{ x: 0, y: 0 }}
        />
        <B4 className="text-primary-150 px-2 font-semibold">
          {i18n.t('brandListing.customerEligibleForFD')}
        </B4>
        <LinearGradientLine
          colors={['#FFFFFF', '#5E9FFF']}
          start={{ x: 1, y: 0 }}
          end={{ x: 0, y: 0 }}
        />
      </XStack>
      <Stack style={styles.imageBackground}>
        <Image
          source={{
            uri: item?.crossSellBackGround,
          }}
          resizeMode="stretch"
          resizeMethod="scale"
          style={styles.bgImage}
        />
        <Stack className="w-[100%] p-4">
          <H4 className="text-center text-white">
            {i18n.locale === 'en'
              ? item?.crossSellTitleEn
              : item?.crossSellTitleHi || ''}
          </H4>
          <XStack className="mb-4 mt-2 items-center justify-center">
            <Approval width={16} height={16} />
            <SH4 className="mx-1 text-[#FFBB26]">
              {i18n.t('brandListing.approvalChance', { percentage: '100' })}
            </SH4>
            <Stack className="h-[12px] w-[2px] bg-[#FFBB26]" />
            <B4 className="mx-1 text-white">{i18n.t('brandListing.earn')}</B4>
            <GradientText
              style={{
                fontSize: 16,
                lineHeight: 24,
                fontWeight: '700',
                fontFamily: 'Graphie-Bold',
              }}
            >
              {'₹' + item?.payout?.amount}
            </GradientText>
          </XStack>
          <Image
            source={{ uri: item?.crossSellBanner }}
            resizeMode="contain"
            style={styles.cardImage}
          />
          <Button
            className="mt-4 w-full bg-[#F9F2FF]"
            size="lg"
            textStyle={'text-[#220A36]'}
            onPress={onBannerPress}
          >
            {i18n.t('brandListing.knowMore')}
          </Button>
        </Stack>
        {/* </ImageBackground> */}
      </Stack>
    </Stack>
  )
}

const styles = StyleSheet.create({
  imageBackground: {
    width: '100%',
    overflow: 'hidden',
    backgroundColor: '#691195',
    borderRadius: 8,
    marginTop: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardImage: {
    height: 240,
    width: '100%',
  },
  bgImage: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundColor: '#691195',
  },
})
